import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SnackBarService } from "cw-utils";
import { ApiGateway } from "../../../../api-gateway";
import { FilterTO } from "../../../../models/operational/filter/filterTO";

@Injectable()
export class CompensatedListProvider {


    constructor(public gw: ApiGateway, public snackBar: SnackBarService) {
    }

    getPage(pageOptions: FilterTO): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`compensated/search`, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

}
